<template>
  <div class="chats">
    <!-- Header -->
    <header-bar></header-bar>
    <!-- Chats -->
    <section class="chat">
      <div class="grid-container">
        <list :chats="chats"></list>
        <conversation v-if="current && current !== 'new'" :id="current" :after="chat.showAfter"></conversation>
        <new v-if="this.$route.params.id === 'new'"></new>
      </div>
    </section>
  </div>
</template>

<script>
import { auth, db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'

import List from '@/components/chat/list/List'
import Conversation from '@/components/chat/conversation/Conversation'
import New from '@/components/chat/new/New'
// import ChatOptions from '@/components/chat/ChatOptions'

export default {
  name: 'Chats',
  data () {
    return {
      chats: [],
      current: this.$route.params.id,
      chat: {}
    }
  },
  firebase () {
    return {
      chat: {
        source: db.ref('users-chats/' + this.$root.user.uid + '/' + this.current),
        asObject: true
      }
    }
  },
  components: {
    HeaderBar,
    List,
    Conversation,
    New
  },
  watch: {
    '$route': function (current, previous) {
      this.current = current.params.id
      if (current.params.id) {
        this.$bindAsObject('chat', db.ref('users-chats/' + this.$root.user.uid + '/' + current.params.id))
      } else {
        this.chat = {}
      }
    }
  },
  beforeCreate: function () {
    db.ref('users/' + this.$root.user.uid + '/unreads').set(0)
    auth.onAuthStateChanged(function (user) {
      if (user) {
        this.$bindAsArray('chats', db.ref('users-chats/' + user.uid).orderByChild('createdAt'))
        this.$bindAsObject('chat', db.ref('users-chats/' + user.uid + '/' + this.current))
      }
    }.bind(this))
  }
}
</script>



// WEBPACK FOOTER //
// Chats.vue?25fe48b2